import { render, staticRenderFns } from "./freight.vue?vue&type=template&id=706cc7fa&scoped=true&"
import script from "./freight.vue?vue&type=script&lang=js&"
export * from "./freight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706cc7fa",
  null
  
)

export default component.exports